<template>
  <div style="width: 100%">
    <v-flex md12 class="d-flex pt-5">
      <v-chip color="primary" label small text-color="white">{{$t('stats')}}</v-chip>
    </v-flex>

    <v-layout wrap>
      <!-- Colonna 1 -->
      <v-flex md3 class="d-flex">
        <v-simple-table>
          <template v-slot:default>
            <tbody>
            <tr>
              <td>Affidabilità</td>
              <td v-if="userForReliability">
                <div class="termometro">
                  <v-progress-linear
                      :value="getReliabilityScore(userForReliability)"
                      height="10"
                      :color="getReliabilityColor(getReliabilityScore(userForReliability), userForReliability)"
                      rounded
                  />
                  <small>{{ getReliabilityScore(userForReliability) }}%</small>
                </div>
              </td>
            </tr>
            <tr>
              <td>Registrato il</td>
              <td class="font-weight-bold">{{ item.created_at ? new Date(item.created_at).toLocaleString() : '-' }}</td>
            </tr>
            <tr>
              <td>Prima prenotazione</td>
              <td class="font-weight-bold">{{ stats.first_booking_date ? new Date(stats.first_booking_date).toLocaleString() : '-' }}</td>
            </tr>
            <tr>
              <td>Ultima prenotazione</td>
              <td class="font-weight-bold">{{ stats.last_booking_date ? new Date(stats.last_booking_date).toLocaleString() : '-' }}</td>
            </tr>
            <tr>
              <td>Lista prenotazioni</td>
              <td class="font-weight-bold">
                <div class="d-flex align-center justify-space-between">
                  <span></span>
                  <v-btn
                      v-if="showLinks"
                      x-small elevation="2" color="primary"
                      @click="goTo(pathBookings, item._id)"
                  >{{ $t('view') }}</v-btn>
                </div>
              </td>
            </tr>
            <tr>
              <td>Lista Cancellazioni</td>
              <td class="font-weight-bold">
                <div class="d-flex align-center justify-space-between">
                  <span></span>
                  <v-btn
                      v-if="showLinks"
                      x-small elevation="2" color="primary"
                      @click="goTo(pathCancellations, item._id)"
                  >{{ $t('view') }}</v-btn>
                </div>
              </td>
            </tr>
            <tr>
              <td>N° Promo Code</td>
              <td class="font-weight-bold">
                <div class="d-flex align-center justify-space-between">
                  <span>{{ count_promo_code }}</span>
                  <v-btn
                      v-if="showLinks"
                      x-small elevation="2" color="primary"
                      @click="goTo(pathPromoCode, item._id)"
                  >{{ $t('view') }}</v-btn>
                </div>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-flex>

      <!-- Colonna 2 -->
      <v-flex md3 class="d-flex">
        <v-simple-table>
          <template v-slot:default>
            <tbody>
            <tr>
              <td>Lista Blacklist</td>
              <td class="font-weight-bold">
                <v-btn
                    v-if="showLinks"
                    x-small elevation="2" color="primary" class="mr-auto"
                    @click="goTo(pathBlacklists, item.email)"
                >{{ $t('view') }}</v-btn>
              </td>
            </tr>
            <tr>
              <td>Segnalazioni totali</td>
              <td class="font-weight-bold">{{ item.blacklist_report || 0 }}</td>
            </tr>
            <tr>
              <td>N° Blacklist bloccato</td>
              <td class="font-weight-bold">
                {{ activeBlacklists }}
              </td>
            </tr>
            <tr>
              <td>N° Blacklist da cui è stato rimosso</td>
              <td class="font-weight-bold">
                {{ canceledBlacklists }}
              </td>
            </tr>
            <tr>
              <td>N° Blacklist in cui è da approvare</td>
              <td class="font-weight-bold">
                {{ pendingBlacklists }}
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-flex>

      <!-- Colonna 3 -->
      <v-flex md3 class="d-flex">
        <v-simple-table>
          <template v-slot:default>
            <tbody>
            <tr>
              <td>N° Prenotazioni Totali</td>
              <td class="font-weight-bold text-center">{{ stats.bookings_count_totals || 0 }}</td>
            </tr>
            <tr>
              <td>Da giocare</td>
              <td class="font-weight-bold info white--text text-center">{{ stats.bookings_count_booked || 0 }}</td>
            </tr>
            <tr>
              <td>Confermate</td>
              <td class="font-weight-bold success white--text text-center">{{ stats.bookings_count_completed || 0 }}</td>
            </tr>
            <tr>
              <td>Da confermare</td>
              <td class="font-weight-bold warning white--text text-center">{{ stats.bookings_count_to_be_confirmed || 0 }}</td>
            </tr>
            <tr>
              <td>Annullate</td>
              <td class="font-weight-bold error white--text text-center">{{ stats.bookings_count_canceled || 0 }}</td>
            </tr>
            <tr>
              <td>Interrotte</td>
              <td class="font-weight-bold error white--text text-center">{{ stats.bookings_count_interrupted || 0 }}</td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-flex>

      <!-- Colonna 4 -->
      <v-flex md3 class="d-flex">
        <v-simple-table>
          <template v-slot:default>
            <tbody>
            <tr>
              <td>N° Prenotazioni in Promo SuperAdmin</td>
              <td class="font-weight-bold text-center">{{ stats.bookings_count_promo_sa || 0 }}</td>
            </tr>
            <tr>
              <td>N° Prenotazioni in promo Centro Sportivo</td>
              <td class="font-weight-bold text-center">{{ stats.bookings_count_promo || 0 }}</td>
            </tr>
            <tr>
              <td>Totale pagato al Centro</td>
              <td class="font-weight-bold text-center">{{ money(stats.total_payed_center) }}</td>
            </tr>
            <tr>
              <td>Totale pagato online</td>
              <td class="text-center font-weight-bold">{{ money(stats.total_payed_online) }}</td>
            </tr>
            <tr>
              <td>Totale da pagare al Centro</td>
              <td class="font-weight-bold text-center">{{ money(stats.total_to_be_payed_center) }}</td>
            </tr>
            <tr>
              <td>Totale da pagare online</td>
              <td class="font-weight-bold text-center">{{ money(stats.total_to_be_payed_online) }}</td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import { getReliabilityScore, getReliabilityColor } from '@/utils/reliability';

export default {
  name: 'CustomerStats',
  props: {
    userId: { type: String, required: true },
    showLinks: { type: Boolean, default: true },
    // opzionali per riusare ovunque
    pathBookings: { type: String, default: '/bookings?user_id=' },
    pathCancellations: { type: String, default: '/cancellations?user_id=' },
    pathPromoCode: { type: String, default: '/promo-codes?user_id=' },
    pathBlacklists: { type: String, default: '/blacklists?search=' }
  },
  data() {
    return {
      item: null,
      stats: {},
      count_promo_code: 0,
      userForReliability: null
    };
  },
  computed: {
    activeBlacklists() {
      const list = this.item && this.item.blacklists || [];
      return list.filter(o => o.status === 'active').length;
    },
    canceledBlacklists() {
      const list = this.item && this.item.blacklists || [];
      return list.filter(o => o.status === 'canceled').length;
    },
    pendingBlacklists() {
      const list = this.item && this.item.blacklists || [];
      return list.filter(o => o.status === 'to_be_approved').length;
    }
  },
  watch: {
    userId: {
      immediate: true,
      handler() {
        this.load();
      }
    }
  },
  methods: {
    getReliabilityScore,
    getReliabilityColor,
    ...mapMutations({ setLoading: 'settings/setLoading' }),
    ...mapActions({ detailsItem: 'customers/details' }),
    async load() {
      try {
        this.setLoading(true);
        const { result } = await this.detailsItem({ id: this.userId });
        this.item = result.user || {};
        this.stats = result.bookings || {};
        this.count_promo_code = result.count_promo_code || 0;

        this.userForReliability = {
          _id: this.item._id,
          name: this.item.name,
          surname: this.item.surname,
          phone: this.item.phone,
          email: this.item.email,
          active: this.item.active,
          image: this.item.image,
          bookings_completed: this.item.bookings_completed,
          created_at: this.item.created_at,
          updated_at: this.item.updated_at,
          bookings_count_completed: this.stats.bookings_count_completed,
          bookings_count_canceled: this.stats.bookings_count_canceled,
          bookings_count_to_be_confirmed: this.stats.bookings_count_to_be_confirmed,
          bookings_count_booked: this.stats.bookings_count_booked,
          bookings_count_interrupted: this.stats.bookings_count_interrupted,
          count_blacklist: this.activeBlacklists,
          count_promo_code: this.count_promo_code,
          phone_verified: this.item.phone_verified,
          email_verified: this.item.email_verified
        };
      } catch (e) {
        // opzionale: notifica centrale
        console.error(e);
      } finally {
        this.setLoading(false);
      }
    },
    goTo(base, value) {
      if (!this.showLinks) return;
      this.$router.push(`${base}${value}`);
    },
    money(v) {
      const n = Number(v || 0);
      return `${n.toFixed(2)} €`;
    }
  }
};
</script>
